import { RequestReducer } from '@common/Checkout/Shopcart/types';
import { RequestState } from '@common/Checkout/Shopcart/types/request';
import { SET_IS_REQUEST_PENDING } from '../actions/constants';

const initialState: RequestState = {
    isPending: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: RequestReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_IS_REQUEST_PENDING: {
            return { ...state, isPending: payload };
        }

        default:
            return state;
    }
};

export default reducer;
